import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";
import EmptyState from "components/EmptyState/EmptyState";
import InnerInput from "components/inputs/InnerInput/InnerInput";
import { assignees, Channel } from "pages/Support/Channels/mockChannels";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../Channel.scss";
import ModalSkeleton from "components/global/Skeleton/ModalSkeleton/ModalSkeleton";

interface Props {
  channel?: Channel;
  isEditMode: boolean;
  isLoading: boolean;
  onChange: (channel: Channel) => void;
}

const ChannelsMainTab: React.FC<Props> = ({
  channel,
  isEditMode,
  isLoading,
  onChange,
}) => {
  const { t } = useTranslation();

  const localChannel = channel as Channel;

  if (isLoading) return <ModalSkeleton />;
  if (!channel) return <EmptyState message={t("noSupportChannelsFound")} />;
  

  const handleFieldChange = (field: keyof Channel, value: any) => {
    const updated = {
      ...channel!,
      [field]: value,
    };

    onChange(updated);
  };

  return (
    <div className="channel-main-tab">
      <div className="form-row">
        <InnerInput
          value={localChannel.title}
          placeholder={t("title")}
          label={t("title")}
          type="string"
          id="channel-title"
          onChange={(value) => handleFieldChange("title", value)}
        />
      </div>

      <div className="form-row">
        <InnerInput
          value={localChannel.slug}
          placeholder={t("slug")}
          label={t("slug")}
          type="string"
          id="channel-slug"
          onChange={(value) => handleFieldChange("slug", value)}
        />
      </div>

      <div className="form-row">
        <DefaultDropdown
          value={localChannel.type}
          label={t("type")}
          options={[
            { value: "chat", label: t("chat") },
            { value: "email", label: t("email") },
          ]}
          disabled={isEditMode}
          onSelect={(value) =>
            handleFieldChange("type", value as "chat" | "email")
          }
          isSmall
        />
      </div>

      <div className="form-row">
        <InnerInput
          id="channel-description"
          label={t("description")}
          type="textarea"
          value={localChannel.description ?? ""}
          placeholder={t("description")}
          onChange={(value) => handleFieldChange("description", value)}
        />
      </div>

      <div className="form-row">
        <DefaultDropdown
          value={localChannel.defaultAssignee}
          placeholder={t("selectAssignee")}
          options={assignees}
          onSelect={(value) =>
            handleFieldChange("defaultAssignee", String(value))
          }
          isSmall
        />
      </div>
    </div>
  );
};

export default ChannelsMainTab;
